import { PureComponent } from 'react'
import { $, img } from 'utils'
import styled from 'glamorous'
import { Icon } from 'components'

const ImageContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'var(--lightGrey)',
  overflow: 'hidden',
  backgroundPosition: 'center',
  backgroundSize: 'cover'
}, ({ width, height, background, isHoverable }) => ({
  width,
  height,
  background,
  ...isHoverable && {
    cursor: 'pointer',
    transition: 'opacity var(--transition)',
    '&:hover': {
      opacity: .85
    }
  }
}), 'imageContainer')

export class ImagePure extends PureComponent {
  state = {
    loaded: false
  }

  onLoad = () => this.setState({ loaded: true })

  render = () => {
    const {
      src,
      width,
      height,
      isExtracted,
      isHoverable,
      negative,
      background = 'var(--lightestGrey)',
      objectFit = 'cover',
      icon = 'persons',
      ...otherProps } = this.props
    return (
      $(ImageContainer, {
        width,
        height,
        background,
        isHoverable
      },
        !src
          ? $(Icon, { type: icon, isHoverable: false, color: 'rgba(0,0,0,.2)', size: width / 1.618 })
          : img({
              src,
              ...otherProps,
              onLoad: this.onLoad,
              style: {
                objectFit,
                height: '100%',
                width: '100%',
                filter: negative ? 'grayscale(100%)' : 'grayscale(0)',
                opacity: this.state.loaded ? 1 : 0,
                transition: 'var(--transition) opacity'
              }
            })
      )
    )
  }
}

export default ImagePure


// WEBPACK FOOTER //
// ./src/components/ImagePure.js